export default __webpack_public_path__ + "static/linen-23ea23f702ec1ae0afe790f45e27e337.png";